import React from 'react';
import { useAppContext, RESET_APP } from 'store';

import winnerImage from '@coursera/assets/images/winner-2-x@3x.png';
import { PluginContainerSuccess } from '@coursera/templates';

function ResultsContainer() {
  const { dispatch } = useAppContext();

  const restart = () => {
    dispatch({ type: RESET_APP });
  };

  return (
    <>
      <PluginContainerSuccess
        header="You’re done!"
        subheader="When searching for interview participants, aim to recruit people with diverse backgrounds, perspectives, and abilities. A representative sample will help you build stronger experiences for all users."
        next={restart}
        img={winnerImage}
      />
    </>
  );
}

export default ResultsContainer;
